export default __webpack_public_path__ + "c12.png";